/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/upload/upload')
require('components/base/loading/loading');

const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const ajaxHttp = require('appUtil/ajaxHttp.js');
const { upload: uploadEvent } = require('components/config/event.json');
const { apiPath } = require('appService/api');

require('./charger-icon-list.scss');
const template = require('./charger-icon-list.tpl');

const chargerIconList = {
  name: "charger-icon-list",

  template,

  data() {
    return {
      detailData: {},
      uploadImg: apiPath.configPush.chargerIcon.uploadIcon,
      speedType: ['维护中', '超速', '快速', '慢速']
    }
  },

  store,

  events: {
    [uploadEvent.change]({store, value}) {
      if (value.length === 0) {
        return false
      }

      ajaxHttp(apiPath.configPush.chargerIcon.updateIcon, {
        type: 'post',
        data: Object.assign(store, {
          img: value[0]
        })
      }).then((rtn) => {

      }).catch((rtn) => {
        tip(rtn.error)
      })
    }
  },

  methods: {
    init() {
      ajaxHttp(apiPath.configPush.chargerIcon.list, {
        data: {
          id: this.$route.params.id
        }
      }).then((rtn) => {
        this.detailData = rtn.data
      }).catch((rtn) => {
        tip(rtn.error)
      })
    }
  },

  ready() {
    this.init()
  }
}

module.exports = chargerIconList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/charger-icon/charger-icon-list.js